import { render, staticRenderFns } from "./SideBarApp.vue?vue&type=template&id=7e80ef97"
import script from "./SideBarApp.vue?vue&type=script&lang=js"
export * from "./SideBarApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports